'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function defineContainer(options) {
  var singletonsSet = new Set(options.singletons); // any: we don't need to type this (its only local)

  var instancesMap = new Map();

  var context = _objectSpread({}, options.context);

  function _resolveSingleton(resolverFn) {
    return new Promise(function (resolvePromise) {
      var instances = instancesMap.get(resolverFn) || []; // do not re-create singletons

      var cached = instances[0];

      if (cached) {
        resolvePromise(cached); // done

        return;
      }

      Promise.resolve(resolverFn(container)).then(function (inst) {
        instances.push(inst);
        instancesMap.set(resolverFn, instances);
        resolvePromise(inst);
      });
    });
  }

  function _resolveDependency(resolverFn) {
    var instances = instancesMap.get(resolverFn) || [];
    var finalPromise = Promise.resolve(resolverFn(container));
    finalPromise = finalPromise.then(function (resolvedValue) {
      instances.push(resolvedValue);
      instancesMap.set(resolverFn, instances);
      return resolvedValue;
    });
    return finalPromise;
  }

  function resolve(resolverFn) {
    return new Promise(function (resolvePromise) {
      if (singletonsSet.has(resolverFn)) {
        resolvePromise(_resolveSingleton(resolverFn));
      } else {
        resolvePromise(_resolveDependency(resolverFn));
      }
    });
  }

  function resolveOnceFromCache(resolverFn) {
    var instances = instancesMap.get(resolverFn) || [];
    return instances[0];
  }

  function resolveOnce(resolverFn) {
    return _resolveSingleton(resolverFn);
  }

  resolveOnce.fromCache = resolveOnceFromCache;

  function resolveNew(resolverFn) {
    return _resolveDependency(resolverFn);
  }

  function debug() {
    return {
      resolved: new Map(instancesMap)
    };
  }

  function clearAll() {
    // Note: promise is not necessary here, but its there to make it consistent w/ reloadAll
    return new Promise(function (resolvePromise) {
      instancesMap.clear();
      resolvePromise();
    });
  }

  function registerSingleton(resolverFn) {
    singletonsSet.add(resolverFn);
  }

  function unregisterSingleton(resolverFn) {
    singletonsSet["delete"](resolverFn);
  } // Note: define it here, so the API can access it (via hoisting)


  var container = {
    resolve: resolve,
    resolveOnce: resolveOnce,
    resolveNew: resolveNew,
    context: context,
    debug: debug,
    clearAll: clearAll,
    // reloadAll,
    registerSingleton: registerSingleton,
    unregisterSingleton: unregisterSingleton
  };
  return container;
}

exports.defineContainer = defineContainer;
